import { useState, type ReactNode } from 'react';
import Tabs from './Tabs';
import AppEmbedFrame from './AppEmbedFrame';
import { embedPolicyForApp } from '../lib/embedConfig';

interface AppViewTabsProps {
  appId: string;
  dashboard: ReactNode;
  embedTitle?: string;
  defaultTab?: 'dashboard' | 'embed';
}

function AppViewTabs({
  appId,
  dashboard,
  embedTitle,
  defaultTab = 'dashboard',
}: AppViewTabsProps) {
  const canEmbed = embedPolicyForApp(appId) === 'allowed';
  const [tab, setTab] = useState<'dashboard' | 'embed'>(defaultTab);

  if (!canEmbed) {
    return <>{dashboard}</>;
  }

  const tabs = [
    { id: 'dashboard', label: 'Dashboard view' },
    { id: 'embed', label: 'Embedded app' },
  ];

  return (
    <div className="space-y-4">
      <Tabs tabs={tabs} active={tab} onChange={(id) => setTab(id as 'dashboard' | 'embed')} />
      {tab === 'dashboard' ? dashboard : (
        <AppEmbedFrame appId={appId} title={embedTitle} className="h-[calc(100vh-14rem)]" />
      )}
    </div>
  );
}

export default AppViewTabs;
